import { render, staticRenderFns } from "./PromotionManagementByPropertyActions.vue?vue&type=template&id=6354ba1d&"
import script from "./PromotionManagementByPropertyActions.vue?vue&type=script&lang=js&"
export * from "./PromotionManagementByPropertyActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports